// Issues page tabs
export const PANELS = ['All Issues'];
export const PANELS_ROUTES = ['/issues/issues'];

// Issue detail modal tabs
export const ISSUE_DETAIL_PANELS = ['Issue Details', 'Events'];
export const ISSUE_DETAIL_PANELS_ROUTES = ['/issue/details', '/issue/events'];
